import { defineMessages } from 'react-intl';

export const messages: {
	unsplashLegal: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	unsplashLicenseLink: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	unsplashNoMoreResultsToLoadText: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	unsplashNoResultsText: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	unsplashLoadMoreAriaLabel: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	unsplashTermsOfServiceLink: {
		defaultMessage: string;
		description: string;
		id: string;
	};
} = defineMessages({
	unsplashNoResultsText: {
		id: 'company-hub.company-hub-common.unsplash.search.no.results.text',
		defaultMessage: 'Nothing matches your search',
		description: 'Text to inform when there are no Unsplash image results to render',
	},
	unsplashLoadMoreAriaLabel: {
		id: 'company-hub.company-hub-common.unsplash.search.load-more.aria-label',
		defaultMessage: 'Load more header images',
		description: 'Accessible label for the button to load more Unsplash header images',
	},
	unsplashNoMoreResultsToLoadText: {
		id: 'company-hub.company-hub-common.unsplash.search.no.more.results.to.load.text',
		defaultMessage: 'No more matches try another search',
		description: 'Text to inform when there are no more Unsplash image results to load',
	},
	unsplashLegal: {
		id: 'company-hub.company-hub-common.unsplash.legal',
		defaultMessage:
			'By using images from Unsplash, you agree to their {unsplashLicenseLink} and {unsplashTermsOfServiceLink}.',
		description: 'Text that explains the Unsplash legal agreements (license and terms of service)',
	},
	unsplashLicenseLink: {
		id: 'company-hub.company-hub-common.unsplash.license',
		defaultMessage: 'license',
		description: 'Text that links to Unsplash license',
	},
	unsplashTermsOfServiceLink: {
		id: 'company-hub.company-hub-common.unsplash.terms.of.service.',
		defaultMessage: 'Terms of Service',
		description: 'Text that links to Unsplash Terms of Service',
	},
});
